export default "__VITE_ASSET__1d288f85__"